var map = {
	"./NOSE1.svg": 89286,
	"./NOSE10.svg": 90897,
	"./NOSE11.svg": 97719,
	"./NOSE11B.svg": 20930,
	"./NOSE12.svg": 18104,
	"./NOSE2.svg": 32768,
	"./NOSE3.svg": 35538,
	"./NOSE4.svg": 93537,
	"./NOSE5.svg": 28977,
	"./NOSE6.svg": 82416,
	"./NOSE7.svg": 4734,
	"./NOSE8.svg": 17065,
	"./NOSE9.svg": 86369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72279;